/**
 * @generated SignedSource<<9f3c40489b575354267b2f3f2e521065>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useGenderCriteria_query$data = {
  readonly currentUser: {
    readonly genderCriteria: {
      readonly nodes: ReadonlyArray<{
        readonly genderId: any;
      } | null | undefined>;
    };
  } | null | undefined;
  readonly " $fragmentType": "useGenderCriteria_query";
};
export type useGenderCriteria_query$key = {
  readonly " $data"?: useGenderCriteria_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGenderCriteria_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGenderCriteria_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "orderBy",
              "value": [
                "GENDER_BY_GENDER_ID__SEQUENCE_ASC"
              ]
            }
          ],
          "concreteType": "GenderCriterionConnection",
          "kind": "LinkedField",
          "name": "genderCriteria",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GenderCriterion",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "genderId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "genderCriteria(orderBy:[\"GENDER_BY_GENDER_ID__SEQUENCE_ASC\"])"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "92353021cc348caf061ef12565985c57";

export default node;
